import $ from 'jquery'

export default function(state, callback) {  
  var settings = {
    "url": "https://bookofnames.josh.christen.se/emailupdate",
    "method": "POST",
    "timeout": 0,
    "crossDomain": true,
    "headers": {
      "Content-Type": "application/json",
    },
    "data": JSON.stringify({
      id: state.id,
      email: state.email,
      unsubscribed: state.unsubscribe,
      frequency: state.frequency
    }),
  };
  
  $.ajax(settings).done(callback);
}
